export const SELECTED_DATE = (startDate: string, endDate: string) =>
  !!startDate && !!endDate
    ? `Selected Dates: ${startDate} to ${endDate}`
    : `Selected Date: ${startDate}`;
